/* Softheld story page — the only behaviour that needs JS: hold the YouTube embed
   back until the poster is clicked, so the page makes no third-party request on
   load. Tab switching is CSS-only (radio + :checked); the Spotify player is
   rendered server-side with loading="lazy". */
(function () {
  var wraps = document.querySelectorAll('[data-sh-video]');
  Array.prototype.forEach.call(wraps, function (wrap) {
    var btn = wrap.querySelector('[data-sh-video-play]');
    var src = wrap.getAttribute('data-embed');
    if (!btn || !src) return;

    btn.addEventListener('click', function () {
      var frame = document.createElement('iframe');
      frame.src = src;
      frame.title = wrap.getAttribute('data-title') || 'The film';
      frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      frame.setAttribute('allowfullscreen', '');
      frame.setAttribute('loading', 'eager');
      while (wrap.firstChild) wrap.removeChild(wrap.firstChild);
      wrap.appendChild(frame);
    });
  });
})();
